module.exports = "images/high_performance_desktops@2x.webp";